import { api } from "..";

export async function deleteSuspendedMatch(
  id: number,
  providerId: number,
  password?: string
) {
  const res = await api.client.post(`/matches/suspended/${id}`, {
    providerId,
    password,
  });
  return res.data;
}
